import { get } from 'lodash';
import { createPropsSelectorOrm } from '../utils';

const emptyObject = {};
export const getRouteData = createPropsSelectorOrm((session, routeCode) =>
  get(session.Route.withId(routeCode), 'ref', emptyObject)
);
